import ReactMarkdown from 'react-markdown';
import { MarkdownProps } from '@common/ts/types';
import { ComponentPropsWithoutRef } from 'react';

function MarkdownUl(props: ComponentPropsWithoutRef<'ul'>) {
  return <ul className="list-disc pl-4" {...props} />;
}

function Markdown({ children, ...rest }: MarkdownProps) {
  if (!children) return null;

  return (
    <ReactMarkdown
      components={{
        ul: MarkdownUl,
      }}
      {...rest}
    >
      {children}
    </ReactMarkdown>
  );
}

export default Markdown;
